var _path, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserRemoved = function SvgUserRemoved(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 9.33337C4.08934 9.33337 2 10.378 2 11.6667C2 12.9554 4.08934 14 6.66667 14C7.51667 14 8.3136 13.8864 9 13.6879",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.66667,
    cy: 4.66667,
    r: 2.66667,
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.0996C14 9.79349 13.9255 9.50514 13.7969 9.24902L11.249 11.7969C11.5051 11.9255 11.7935 12 12.0996 12C13.149 12 14 11.149 14 10.0996ZM10.1992 10.0996C10.1992 10.4053 10.2731 10.6934 10.4014 10.9492L12.9492 8.40137C12.6934 8.27313 12.4053 8.19922 12.0996 8.19922C11.0503 8.19922 10.1992 9.05027 10.1992 10.0996ZM15.1992 10.0996C15.1992 11.8117 13.8117 13.1992 12.0996 13.1992C10.3875 13.1992 9 11.8117 9 10.0996C9 8.38753 10.3875 7 12.0996 7C13.8117 7 15.1992 8.38753 15.1992 10.0996Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0996 9.09961L11.0996 11.0996",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserRemoved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "user-removed.bd19dc1f670115bef59f921dc7e1f95e.svg";